import { render, staticRenderFns } from "./WealthContent.vue?vue&type=template&id=ff4a67ba&scoped=true"
import script from "./WealthContent.vue?vue&type=script&lang=ts"
export * from "./WealthContent.vue?vue&type=script&lang=ts"
import style0 from "./WealthContent.vue?vue&type=style&index=0&id=ff4a67ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff4a67ba",
  null
  
)

export default component.exports